<div class="row">
  <div class="col-8 px-0">
    <div *ngIf="transactionType && product" class="d-xs-block d-lg-none">
      <dcp-lead-form-header [ctaLabel]="transactionType.ctaLabel" [isMobileTitle]="true"
                            class="mb-0"></dcp-lead-form-header>
      <ng-container *ngTemplateOutlet="productInfo"></ng-container>
      <div *ngIf="product.vendor" class="d-flex flex-nowrap ds-fine-print ds-color--grey-2 mt-1">
        <ng-container *ngIf="showCtaFrom">{{'productDetails.from' | cxTranslate}}</ng-container>
        <span [ngClass]="{'ms-1': showCtaFrom}">{{product.vendor.name}}</span></div>
    </div>
  </div>
  <div *ngIf="image"
       class="col-auto col-lg-12 order-first order-lg-2 mb-0 mb-lg-4 mt-lg-5 text-center pe-3 p-lg-0">
    <cx-media
      [alt]="'leadForm.sections.productIcon' | cxTranslate"
      [container]="{url: image.url}"
      class="product-icon mx-auto d-flex align-items-center p-1 p-md-3"
      format="thumbnail">
    </cx-media>
  </div>
  <div *ngIf="product" class="col col-lg-12 order-lg-3 d-none d-lg-block">
    <ng-container *ngTemplateOutlet="productInfo"></ng-container>
  </div>
</div>
<ng-template #productInfo>
  <h3 class="product-name">{{product.name}}</h3>
</ng-template>
